enum MenuPriceStyle {
  Default = 0,
  OneDigit = 1,
  TwoDigits = 2,
}

export { MenuPriceStyle };
